module.exports = __webpack_public_path__ + "img/gh.6214e64a.svg";